import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {DetailsNoteCreditTransacctionComponent} from '../../../shared/modals/details-note-credit-transacction/details-note-credit-transacction.component'

@Component({
  selector: 'app-generate-credit-note-confirmation',
  templateUrl: './generate-credit-note-confirmation.component.html',
  styleUrls: ['./generate-credit-note-confirmation.component.scss']
})
export class GenerateCreditNoteConfirmationComponent implements OnInit {

  otherModalRef?:BsModalRef;

  constructor(private modalsSvc: BsModalService, private modalRef: BsModalRef) { }

  
  ngOnInit(): void {

    if(this.otherModalRef){
      this.otherModalRef.hide();
    }

  }

  close(){
    this.modalsSvc.hide();
  }

  open(){
    this.modalsSvc.show(DetailsNoteCreditTransacctionComponent,{
      class: 'modal-lg modal-expanded',
      initialState:{
        otherRef: this.modalRef
      }
    })
    
    
  }
}
